import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
const ContactPage = ({ onBack, showToast }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('Contact from Swim Lab');
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!message.trim()) {
            showToast('Please enter a message before sending.', 'error');
            return;
        }
        if (!email.trim()) {
            showToast('Please provide your email address so we can reply.', 'error');
            return;
        }
        setSubmitting(true);
        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: name.trim() || 'Anonymous',
                    email: email.trim(),
                    subject: subject.trim(),
                    message: message.trim(),
                }),
            });
            if (!response.ok) {
                const error = await response.json().catch(() => ({ error: 'Failed to send message' }));
                throw new Error(error.error || 'Failed to send message');
            }
            showToast('Message sent successfully!', 'success');
            setName('');
            setEmail('');
            setSubject('Contact from Swim Lab');
            setMessage('');
        }
        catch (error) {
            showToast(`Error sending message: ${error.message}`, 'error');
        }
        finally {
            setSubmitting(false);
        }
    };
    return (React.createElement("section", { className: "contact-page card" },
        React.createElement("div", { className: "section-header" },
            React.createElement("button", { className: "btn-ghost section-toggle", onClick: onBack, title: "Back to home" },
                React.createElement(FontAwesomeIcon, { icon: faArrowLeft }),
                " Back"),
            React.createElement("h2", null, "Contact Swim Lab")),
        React.createElement("p", { style: { marginBottom: '1rem', color: 'var(--text-secondary)' } }, "Have a question or feedback? Fill out the form below and we'll get back to you as soon as possible."),
        React.createElement("form", { className: "contact-form", onSubmit: handleSubmit },
            React.createElement("label", null,
                "Name",
                React.createElement("input", { type: "text", value: name, onChange: e => setName(e.target.value), placeholder: "Your name (optional)", disabled: submitting })),
            React.createElement("label", { style: { display: 'flex', flexDirection: 'column', gap: 4 } },
                React.createElement("span", { style: { display: 'flex', alignItems: 'center', gap: 4 } },
                    "Email ",
                    React.createElement("span", { className: "required-asterisk" }, "*")),
                React.createElement("input", { type: "email", value: email, onChange: e => setEmail(e.target.value), placeholder: "Your email address", required: true, disabled: submitting })),
            React.createElement("label", null,
                "Subject",
                React.createElement("input", { type: "text", value: subject, onChange: e => setSubject(e.target.value), disabled: submitting })),
            React.createElement("label", { style: { display: 'flex', flexDirection: 'column', gap: 4 } },
                React.createElement("span", { style: { display: 'flex', alignItems: 'center', gap: 4 } },
                    "Message ",
                    React.createElement("span", { className: "required-asterisk" }, "*")),
                React.createElement("textarea", { value: message, onChange: e => setMessage(e.target.value), rows: 7, placeholder: "Write your message here...", required: true, disabled: submitting })),
            React.createElement("button", { type: "submit", className: "btn", style: { marginTop: '1rem' }, disabled: submitting },
                React.createElement(FontAwesomeIcon, { icon: faPaperPlane }),
                " ",
                submitting ? 'Sending...' : 'Send Message'))));
};
export default ContactPage;
